export enum CSVImportStatus {
	NOT_STARTED = 'not_started',
	IN_PROGRESS = 'in_progress',
	COMPLETED = 'completed',
	FAILED = 'failed'
}

export interface CSVImportLogResponse {
	status: CSVImportStatus
	id: number
	updated_at: string
	organization_id: number
	csv_url: string
	created_at: string
}
